/* eslint-disable */
export default {
  noRecords: 'Keine aktuellen Einträge gefunden.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
